import _ from 'lodash';
import moment from 'moment-timezone';

export const WEEKDAY_IDS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'];
export const WEEKDAY_NAMES = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
export const WEEKDAY_SHORT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export const SLOT_TYPES = ['private', 'plan'];

const FORMAT = 'HH:mm';

export function durationToMinutes(duration) {
  if (!duration) {
    return 0;
  }
  return moment.duration(duration).asMinutes();
}

function windowTimes(begin, end, durationMin) {
  const times = [];
  if (!begin || !end || !begin.length || !end.length || durationMin <= 0) {
    return times;
  }
  const startWindow = moment(begin, FORMAT);
  const endWindow = moment(end, FORMAT);
  const nSlots = Math.floor(endWindow.diff(startWindow, 'minutes') / durationMin);
  let time = startWindow.clone();
  for (let i = 0; i < nSlots; i += 1) {
    times.push(time.format(FORMAT));
    time = time.add(durationMin, 'm');
  }
  return times;
}

export function generateDayTimes(rule, duration) {
  const durationMin = durationToMinutes(duration);
  if (!rule || durationMin <= 0) {
    return [];
  }
  return [
    ...windowTimes(rule.morningBegin, rule.morningEnd, durationMin),
    ...windowTimes(rule.afternoonBegin, rule.afternoonEnd, durationMin),
  ];
}

// rules: objeto { seg: {...} } ou array [{ id: 'seg', ... }].
// Retorna { seg: ['08:00', ...] } só com dias que geram vagas.
export function generateWeekGrid(rules, duration) {
  const grid = {};
  const entries = Array.isArray(rules)
    ? rules.map((rule) => [rule.id, rule])
    : Object.entries(rules || {});
  entries.forEach(([dayId, rule]) => {
    const times = generateDayTimes(rule, duration);
    if (times.length > 0) {
      grid[dayId] = times;
    }
  });
  return grid;
}

export function isSlotClosed(closed, type, dayId, time) {
  return !!(closed
    && closed[type]
    && closed[type][dayId]
    && closed[type][dayId][time]);
}

// Mantém no mapa de fechados só as chaves que existem na grade atual.
export function pruneClosedToGrid(closed, grid) {
  const pruned = {};
  SLOT_TYPES.forEach((type) => {
    pruned[type] = {};
    Object.keys(grid).forEach((dayId) => {
      const dayTimes = {};
      grid[dayId].forEach((time) => {
        if (isSlotClosed(closed, type, dayId, time)) {
          dayTimes[time] = true;
        }
      });
      if (Object.keys(dayTimes).length > 0) {
        pruned[type][dayId] = dayTimes;
      }
    });
  });
  return pruned;
}

// Formato legado: slot bloqueado no online = fechado para todos os tipos habilitados.
export function deriveBlockedFromClosed(closed, modeArr, grid) {
  const enabledTypes = SLOT_TYPES.filter((type) => modeArr.includes(type));
  const blocked = {};
  if (enabledTypes.length === 0) {
    return blocked;
  }
  Object.keys(grid).forEach((dayId) => {
    const times = grid[dayId]
      .filter((time) => enabledTypes.every((type) => isSlotClosed(closed, type, dayId, time)))
      .map((time) => ({ time }));
    if (times.length > 0) {
      blocked[dayId] = times;
    }
  });
  return blocked;
}

// Estado inicial da tela: onlineSlots quando presente; senão deriva do bloqueio
// legado (fechado para os dois tipos). Cotas numéricas não mapeiam para slots.
export function getInitialClosed(scheduleSettings) {
  const settings = scheduleSettings || {};
  if (settings.onlineSlots && settings.onlineSlots.closed) {
    const closed = _.cloneDeep(settings.onlineSlots.closed);
    SLOT_TYPES.forEach((type) => {
      if (!closed[type]) {
        closed[type] = {};
      }
    });
    return closed;
  }
  const closed = { private: {}, plan: {} };
  Object.entries(settings.onlineSchedulesBlocked || {}).forEach(([dayId, arr]) => {
    (arr || []).forEach(({ time }) => {
      SLOT_TYPES.forEach((type) => {
        if (!closed[type][dayId]) {
          closed[type][dayId] = {};
        }
        closed[type][dayId][time] = true;
      });
    });
  });
  return closed;
}
